/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2019 Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

angular.module('bulbApp.offBoardingModule')
  .component('bulbOffboarding', {

    templateUrl: 'ajs/components/offboarding/offboarding-modal.html',
    controllerAs: 'offBoardingCtrl',
    controller: ['$log', '$translate', '$modalStack', 'moment', 'BulbAuthService', 'BulbBusyService', 'Restangular',
      OffBoardingController],

  });

// Controller to handle the off-boarding logic
function OffBoardingController($log, $translate, $modalStack, moment, BulbAuthService, BulbBusyService, Restangular) {
  const that = this;
  // Needed translation for the HTML template:
  this.loginExists = $translate.instant('off_board_modal_login_exists');
  this.currentUser = BulbAuthService.currentUser;
  this.currentUserPrefs = this.currentUser.prefs;

  // Submit function for the form:
  this.submit = function () {
    BulbBusyService.showBusyDuring(
      // Update the account's email and password:
      Restangular.one('accounts', that.currentUser.id).customPOST({ email: that.newEmail }, 'emails').then(() => {
        // Update the user's prefs offboarding object isEmailAdded value:
        that.currentUserPrefs.offBoarding.isEmailAdded = true;
        Restangular.one('accounts', that.currentUser.id).patch({ prefs: that.currentUserPrefs }).catch((error) => {
          $log.error(
            'Failed to update the currentUsers offboarding isEmailAdded flag for account id: ',
            that.currentUser.id,
            ' with error: ',
            error,
          );
        });
      }).catch((error) => {
        $log.error('failed to update the currentUsers email with account id: ', that.currentUser.id, ' with error: ', error);
      })
        .then(() => {
        // Now we do a call to update the password for the account:
        // Note: If the account already has one, the new password will not be an input option here.
          if (typeof that.newPasword !== 'undefined') {
            Restangular.one('accounts', that.currentUser.id).patch({ password: that.newPasword }).catch((error) => {
              $log.error('Failed to update the currentUsers password with account id: ', that.currentUser.id, ' with error: ', error);
            });
          }
        }),
    ).finally(() => {
      // We finally close the modal if we succeeded with both calls:
      closeModals();
    });
  };

  /**
   * Function to set the logic for the 'remind me later' functionality:
   */
  this.remindMeLater = function () {
    const currentDateTimeStamp = moment.utc(Date.now());
    // Calculate a week ahead from once they click the 'remind me later'
    const weekAhead = currentDateTimeStamp + (7 * 24 * 60 * 60 * 1000);
    that.currentUserPrefs.offBoarding.remindMeLaterDate = weekAhead;

    // Update the current user's off-boarding preferences:
    Restangular.one('accounts', that.currentUser.id).patch({ prefs: that.currentUserPrefs }).catch((error) => {
      $log.error(`Failed to save offboarding remind me later date ${error}`);
    });

    // Now close the modal:
    closeModals();
  };

  /**
   * Close all modals instances.
   */
  function closeModals() {
    $modalStack.dismissAll('cancel');
  }

  // Logic to handle that the senior already has an alternative account:
  this.alreadyHaveAccount = function () {
    // In this case, we just explicitly set the 'isEmailAdded' from within the prefs off-boarding object to true:
    that.currentUserPrefs.offBoarding.isEmailAdded = true;

    // Update the current user's off-boarding preferences:
    Restangular.one('accounts', that.currentUser.id).patch({ prefs: that.currentUserPrefs }).catch((error) => {
      $log.error(`failed to save acceptance of latest terms ${error}`);
    });

    // Now close the modals:
    closeModals();
  };
}
